"use client";

import { RouterLink } from "@/components/RouterLink/RouterLink";
import { Splash } from "@/components/Splash/Splash";
import { useTheme } from "@/hooks/useTheme";
import { useUser } from "@/hooks/useUser";
import { Button } from "@cloudspire/shared/components/ui/button";
import { Flex } from "@cloudspire/shared/components/ui/flex";
import { useRouters } from "@cloudspire/shared/hooks/useRouters";
import { useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";

export function Error404() {
  const intl = useIntl();

  const { nextjsAccountRouter } = useRouters();

  const { theme } = useTheme();

  const { user } = useUser();

  const url = useMemo(() => {
    if (user) {
      return nextjsAccountRouter.getUrl({
        id: "@account-v2/account",
      });
    } else {
      return nextjsAccountRouter.getUrl({ id: "@account-v2/sign-in" });
    }
  }, [nextjsAccountRouter, user]);

  return (
    <Flex
      flexDirection="column"
      h="100dvh"
      justifyContent="center"
      px="16px"
      py="32px"
    >
      <Splash
        description={intl.formatMessage({
          defaultMessage: "Code d’erreur: 404",
        })}
        src={nextjsAccountRouter.getUrl({
          id: "@account-v2/assets",
          parameters: { resource: `/assets/splashes/not-found/${theme}.svg` },
        })}
        title={intl.formatMessage({
          defaultMessage: "Cette page est introuvable ou n’existe pas",
        })}
      >
        <RouterLink asChild href={url}>
          <Button as="a" colorPalette="primary">
            <FormattedMessage defaultMessage="Revenir à l’accueil" />
          </Button>
        </RouterLink>
      </Splash>
    </Flex>
  );
}
